/**
 * Shared scheduling constants used by both the authenticated ScheduleCardModal
 * and the guest scheduling flow.
 */

import { TimeSlot } from '../types';

/**
 * Time slot options for delivery time selection.
 * Each option shows a user-friendly label with the time window.
 */
export const TIME_SLOT_OPTIONS = [
  { value: TimeSlot.EarlyMorning, label: 'Early Morning (5-8 AM)' },
  { value: TimeSlot.Morning, label: 'Morning (8 AM-12 PM)' },
  { value: TimeSlot.Afternoon, label: 'Afternoon (12-5 PM)' },
  { value: TimeSlot.Evening, label: 'Evening (5-9 PM)' },
];

/** sessionStorage key for the guest card scheduling draft saved before sign-up */
export const GUEST_DRAFT_STORAGE_KEY = 'scheduledsmiles_guest_draft';

/** sessionStorage key for the guest flower order draft saved before sign-up */
export const GUEST_FLOWER_DRAFT_STORAGE_KEY = 'scheduledsmiles_guest_flower_draft';

/** sessionStorage key for the guest mailed-card order draft saved before sign-up */
export const GUEST_MAILED_CARD_DRAFT_STORAGE_KEY = 'scheduledsmiles_guest_mailed_card_draft';
